import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'navigation_tree_ux-categories_menu_button-click';
/**
 * Track clicking the button that opens the categories menu
 */ export function trackNavigationTreeUxCategoriesMenuButtonClick(action) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            action: action
        }
    });
}
